import React from 'react'
import QuantityInput from '../../utils/quantity-input'
import ProductSelector from './batch-product-selector'
import Filters from '../detailed/filters'
import SelectAllCheckbox from '../../app-templates/ope-checkbox'
import EditorActions from '../../../actions/editor-actions'
import AdobeAnalytics from '../../../utils/adobe-analytics'
import SelectorActions from '../../../actions/selector-actions'
import UploadStore from '../../../stores/upload-store'
import OrderStore from '../../../stores/order-store'
import createReactClass from 'create-react-class'


/**
 * Get data from the Upload Store which keeps track of changes in how many images are added and currently uploaded
 * @return {Object}
 */
function uploadData() {
	return UploadStore.getData();
}

/**
 * The batch toolbar with the batch buttons and options
 */
var BatchOptions = createReactClass({
	getInitialState: function() {
		return {
			filterExpanded: false, batchChecked: OrderStore.allBatchItemsSelected(), upload: uploadData(), batchFilterSelected: OrderStore.getSelectedBatchFilter()
		}
	},

	componentWillMount: function() {
	    UploadStore.addChangeListener(this._onChange);
	    OrderStore.addChangeListener(this._onChange);
	},

	componentWillUnmount: function() {
	    UploadStore.removeChangeListener(this._onChange);
	    OrderStore.removeChangeListener(this._onChange);
	},

	_batchDone: function() {
		this.props.doneCallback();
	},

	_onChange: function () {
        this.setState({upload: uploadData(), batchFilterSelected: OrderStore.getSelectedBatchFilter()});
	},

	applyQuantityToOrder: function(value) {
		this.props.quantityCallback(value);
	},

	batchSelectAll: function(event) {
		var target = event.target;
		this.setState({batchChecked: target.checked });
		SelectorActions.toggleOrderBatchState(target.checked);
	},

	filterCallback: function(filterValue) {
		EditorActions.batchFilterValue(filterValue);
	},

	toggleFilterBatch: function() {
		document.getElementById("batchFilterButton").blur();
		this.setState({filterExpanded: !this.state.filterExpanded });
	},

	isReadyForBatchOptions: function () {
		//If there has been added any images to the uploader, all of them must be registered before enabling batch options
		if (this.state.upload.totalImagesToUpload > 0) {
			return (this.state.upload.totalImagesToUpload === this.state.upload.totalImagesRegistered);
		}

		return true;
	},

	render: function() {
		var instance = this, filter = <span />;

		if (!this.isReadyForBatchOptions()) {
			return (
				<div className="ope-batch__waitmessage">
					{_("Editing multiple photos will be available when all the photos are analyzed")}
				</div>
			);
		}

		if(instance.state.filterExpanded) {
			filter =
				<div className="ope-batch__filter-menu" key={Math.random()} >
					<Filters callback={instance.filterCallback} batchFilterSelected={this.state.batchFilterSelected} />
				</div>;
		}

		return (
			<div>
				<section className="ope-product-list__batch">
					<div className="ope-product-list__batch__content row">
						<div className="ope-product-list__checkbox small-5 medium-2 columns ope-grid-column-nopadding">
							<SelectAllCheckbox isChecked={this.state.batchChecked} checkboxId="selectAll" callback={this.batchSelectAll} checkboxClassName="ope-batch__select-all" />
						</div>
						<div className="ope-product-list__batch__size small-3 medium-4 columns ope-grid-column-nopadding">
							<ProductSelector label={_("Choose size")} id="batchFormat" className="ope-product-list__batch__product-select">

							</ProductSelector>
						</div>

						<div className="ope-product-list__batch__filter small-2 medium-3 columns ope-grid-column-nopadding">
							<select id="batchFilterButton" onClick={this.toggleFilterBatch}>
								<option value="1">{_("Add filter")}</option>
							</select>
						</div>

						<div className="ope-product-list__batch__quantity small-2 medium-3 columns ope-grid-column-nopadding">
							<div className="ope-product-list__batch__quantity__label">
							  {_("Quantity:")}
							</div>
							<QuantityInput wrapperClassName="ope-product-list__batch__quantity__input" value={this.props.quantityValue} callback={this.applyQuantityToOrder}/>
						</div>
					</div>
				</section>

				{ filter }
			</div>
		);
	}
});

export default BatchOptions;
